document.addEventListener('DOMContentLoaded', function () {

    'use strict';

    function setVideoToggle(video, playing) {
        const btn = video.nextElementSibling;
        if (!btn || !btn.classList.contains('video-toggle')) return;
        if (playing) {
            btn.classList.replace('icon-play', 'icon-pause');
            btn.setAttribute('aria-label', 'Pausa video');
        } else {
            btn.classList.replace('icon-pause', 'icon-play');
            btn.setAttribute('aria-label', 'Spela upp video');
        }
    }

    function checkVisibility() {
        const elements = document.querySelectorAll('.scroll-animation');
        const videos = document.querySelectorAll('video');
        const bottomOfScreen = window.scrollY + window.innerHeight - 200;
        const topOfScreen = window.scrollY;

        elements.forEach(function(element) {
            const topOfElement = element.getBoundingClientRect().top + window.scrollY;
            const bottomOfElement = topOfElement + element.offsetHeight;

            if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement && !element.classList.contains('is-visible')) {
                element.classList.add('is-visible');
            }
        });

        videos.forEach(function(video) {
            const topOfElement = video.getBoundingClientRect().top + window.scrollY;
            const bottomOfElement = topOfElement + video.offsetHeight;
            const inView = bottomOfScreen > topOfElement && topOfScreen < bottomOfElement;

            const flyout = video.closest('.flyout-wrapper');
            const flyoutActive = !flyout || flyout.classList.contains('active');

            if (inView && flyoutActive) {
                if (video.paused && !video.dataset.userPaused && video.hasAttribute('autoplay')) {
                    video.play();
                    setVideoToggle(video, true);
                }
            } else {
                if (!video.paused) {
                    video.pause();
                    setVideoToggle(video, false);
                }
            }
        });
    }

    document.querySelectorAll('.video-toggle').forEach(function(btn) {
        const video = btn.previousElementSibling;
        if (!video || video.tagName !== 'VIDEO') return;

        btn.addEventListener('click', function() {
            if (video.paused) {
                delete video.dataset.userPaused;
                video.play();
                setVideoToggle(video, true);
            } else {
                video.dataset.userPaused = '1';
                video.pause();
                setVideoToggle(video, false);
            }
        });
    });

    setTimeout(checkVisibility, 2000);

    window.addEventListener('scroll', checkVisibility);

    const flyouts = document.querySelectorAll('.flyout-wrapper');
    flyouts.forEach(flyout => {
        const observer = new MutationObserver(() => {
            checkVisibility();
        });
        observer.observe(flyout, { attributes: true, attributeFilter: ['class'] });
    });
});

//# sourceMappingURL=above-the-fold.js.map
